//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ContractOfferView',
  components: {
    Section: () => import('@/components/common/Section')
  },
  layout: 'documentation',
  data () {
    return {
      document: null
    }
  },
  computed: {
    title () {
      return this?.document?.title
    },
    description () {
      return this?.document?.description
    }
  },
  async mounted () {
    await this.$axios.$get(`/api/documents/contract-offer?lang=${this.$i18n.locale}`)
      .then(resolve => this.document = resolve.data)
      .catch(() => this.document = {})
  }
}
